/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { Router } from '@angular/router';

import { SearchService } from './services/search.service';

@Component({
  selector: 'xbaht-navbar-search',
  templateUrl: './navbar-search.component.html',
  styleUrl: './navbar-search.component.scss',
  standalone: false
})
export class NavbarSearchComponent implements OnInit {
  public searchText = '';
  public openSearchRef = false;
  public activeIndex = 0;
  public apiData: any;
  public pages = [];
  public files = [];
  public contacts = [];
  public pageSearchLimit: any;

  @ViewChild('openSearch') private _inputElement!: ElementRef;
  @ViewChild('pageList') private _pageListElement!: ElementRef;

  @HostListener('keydown.escape') public fn() {
    this.removeOverlay();
    this.openSearchRef = false;
    this.searchText = '';
  }
  @HostListener('document:click', ['$event']) public clickout(event: any) {
    if (event.target.className === 'content-overlay') {
      this.removeOverlay();
      this.openSearchRef = false;
      this.searchText = '';
    }
  }

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _elementRef: ElementRef,
    private router: Router,
    public _searchService: SearchService
  ) {}

  ngOnInit(): void {
    this._searchService.onApiDataChange.subscribe((res) => {
      this.apiData = res;
      this.pages = this.apiData[0].data;
      this.pageSearchLimit = this.apiData[0].searchLimit;
      this.files = this.apiData[1].data;
      this.contacts = this.apiData[2].data;
    });
  }

  public nextActiveMatch() {
    this.activeIndex =
      this.activeIndex < this.pageSearchLimit - 1
        ? ++this.activeIndex
        : this.activeIndex;
  }

  public prevActiveMatch() {
    this.activeIndex = this.activeIndex > 0 ? --this.activeIndex : 0;
  }

  public removeOverlay() {
    this.document
      .querySelector('.app-content')
      .classList.remove('show-overlay');
  }

  public autoSuggestion(event: any) {
    if (38 === event.keyCode) {
      return this.prevActiveMatch();
    }
    if (40 === event.keyCode) {
      return this.nextActiveMatch();
    }
    if (13 === event.keyCode) {
      const current_item =
        this._pageListElement.nativeElement.getElementsByClassName(
          'current_item'
        );
      current_item[0]?.children[0].click();
    }
  }

  public toggleSearch() {
    this._searchService.onIsBookmarkOpenChange.next(false);
    this.removeOverlay();
    this.openSearchRef = !this.openSearchRef;
    this.activeIndex = 0;
    setTimeout(() => {
      this._inputElement.nativeElement.focus();
    });

    if (this.openSearchRef === false) {
      this.document
        .querySelector('.app-content')
        .classList.remove('show-overlay');
      this.searchText = '';
    }
  }

  public searchUpdate(event: any) {
    const val = event.target.value.toLowerCase();
    if (val !== '') {
      this.document.querySelector('.app-content').classList.add('show-overlay');
    } else {
      this.document
        .querySelector('.app-content')
        .classList.remove('show-overlay');
    }
    this.autoSuggestion(event);
  }

  public navigate(link: string): void {
    this.router.navigate([link]);
  }
}
